import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import ProgramCostRow from './ProgramCostRow';
import TrueImpactAddButton from '../ImpactIndicator/TrueImpactAddButton';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { numberWithCommas } from 'shared/utils/numberUtils';
import { Cost } from './utils';
import { MEDIA_BREAKPOINTS } from 'shared/design-system/settings/variables/Breakpoints';
import { dollarAmountDefaultValue } from 'shared/design-system/components/TrueImpactDollarField';

interface ProgramCostModalContentProps {
  reportId: number | string;
  defaultCostList: Cost[];
  total: number;
  handleTotal: (total: number) => unknown;
}

const StyledDiv = styled.div`
  padding: ${SPACERS.large};
  .add-cost-button {
    max-width: 317px;
    justify-content: center;
    margin-top: ${SPACERS.small};
    margin-left: auto;
    margin-right: auto;
  }
  .total-cost {
    margin-top: ${SPACERS.tiny};
  }
  .category-grid {
    display: grid;
    gap: ${SPACERS.tiny};
    padding-right: 140px;
    grid-template-columns: 1fr 1fr;
  }
  ${MEDIA_BREAKPOINTS.smallerThanLarge} {
    .category-grid {
      padding-right: 0px;
    }
  }
  @media screen and (max-width: 600px) {
    .category-grid {
      grid-template-columns: 1fr;
    }
  }
`;

const ProgramCostModalContent: React.FC<ProgramCostModalContentProps> = ({
  total,
  defaultCostList,
  handleTotal,
}) => {
  const [list, setList] = useState<Cost[]>(defaultCostList);

  useEffect(() => {
    let total = 0;
    list.forEach(l => {
      total += parseFloat(l.value.replace(/,/g, '')) || 0;
    });
    handleTotal(total);
  }, [list, handleTotal]);

  const handleChange = useCallback(
    (cost: Cost, index: number) => {
      setList(s => {
        const newState = [...s];
        newState[index] = cost;
        return newState;
      });
    },
    [setList],
  );
  const handleDelete = useCallback(
    (index: number) => {
      setList(s => {
        const newState = [...s];
        newState.splice(index, 1);
        return newState;
      });
    },
    [setList],
  );
  const handleAdd = useCallback(() => {
    setList(s => {
      const newState = [...s];
      newState.push({ value: '', text: '' });
      return newState;
    });
  }, [setList]);

  return (
    <StyledDiv>
      <div className="category-grid">
        {list.map((l, i) => (
          <ProgramCostRow
            type={i % 2 === 0 ? 'flex' : 'grid'}
            key={`${i}-${l.text}`}
            index={i}
            cost={l}
            handleChange={handleChange}
            handleDelete={handleDelete}
          />
        ))}
      </div>
      <TrueImpactAddButton
        text="Category"
        onClick={handleAdd}
        className="add-cost-button"
      />
      <ProgramCostRow
        index={-1}
        type="grid"
        disabled={true}
        cost={{
          text: 'Total',
          value: numberWithCommas(total.toFixed(2)),
        }}
        handleChange={() => null}
        className="total-cost"
      />
    </StyledDiv>
  );
};

export default ProgramCostModalContent;
